const es = {
  home: {
    hero: {
      alt: 'Logotipo de Panch Tatva',
      tagline: 'Una exploración tranquila del equilibrio, la presencia y los cinco elementos.',
      cta: 'Entrar en los Elementos',
    },
    collection: {
      title: 'Los Elementos',
      description:
        'Cada elemento refleja un estado del ser — expresado a través de la forma, la textura y la intención.',
    },
    about: {
      title: 'Nuestra Filosofía',
      paragraphs: [
        'Panch Tatva es una filosofía basada en la comprensión de que el equilibrio no se crea — se recuerda.',
        'A través de la conciencia elemental y la creación consciente, el trabajo explora cómo los objetos cotidianos pueden apoyar la presencia, el ritmo y la alineación tranquila en la vida moderna.',
      ],
    },
  },
  nav: {
    home: 'Inicio',
    shop: 'Tienda',
    about: 'Acerca de',
    cart: 'Carrito',
    logoAlt: 'Logotipo de Panch Tatva por Anukta',
  },
  footer: {
    brand: 'Panch Tatva',
    tagline: 'Una filosofía de equilibrio elemental expresada a través de creaciones conscientes.',
    explore: ['Inicio', 'Los Elementos', 'Filosofía', 'Rituales', 'Tienda'],
    exploreTitle: 'Explorar',
    contact: {
      email: 'support@panch-tatva.co.in',
      phone: '+91 6390725752',
    },
    contactTitle: 'Contacto',
    legal: [
      '“Panch Tatva by Anukta” es una marca y filosofía operada por Anukta Panchatatva LLP.',
      '© 2026 Panch Tatva by Anukta™. Todos los derechos reservados.',
    ],
  },
  card: {
    addToCart: 'Agregar al carrito',
    viewDetails: 'Ver detalles',
  },
  cart: {
    title: 'Tu carrito',
    empty: 'Tu carrito está vacío',
    remove: 'Eliminar',
    totalPrefix: 'Total:',
    checkout: 'Pagar',
    guestBanner: 'Inicia sesión para guardar tu carrito en todos tus dispositivos', // TODO: professional translation
  },
  checkout: {
    guestSignInPrompt: 'Inicia sesión para un pago más rápido', // TODO: professional translation
    // Address section
    shippingAddress: 'Dirección de envío',
    savedAddresses: 'Direcciones guardadas',
    addNewAddress: '+ Agregar nueva dirección',
    useThisAddress: 'Usar esta dirección',
    noSavedAddresses: 'No se encontraron direcciones guardadas',
    loadingAddresses: 'Cargando tus direcciones…',
    addressLoadError: 'No se pudieron cargar las direcciones guardadas. Ingresa manualmente.',
    // Address form fields
    fullName: 'Nombre completo',
    phone: 'Número de teléfono',
    email: 'Correo electrónico',
    addressLine: 'Dirección',
    city: 'Ciudad',
    state: 'Estado',
    pincode: 'Código postal',
    saveAsDefault: 'Guardar como dirección predeterminada',
    // Shipping options section
    deliveryMethod: 'Método de entrega',
    fetchingRates: 'Obteniendo tarifas de envío…',
    shippingRatesFor: 'Tarifas para',
    noShippingOptions: 'No hay servicios de mensajería disponibles para este código postal.',
    shippingFallback: 'Tarifas en vivo no disponibles — se muestran opciones estándar.',
    shippingApiError: 'No se pudieron cargar las tarifas. Usando opciones estándar.',
    ratesUpdating: 'Actualizando tarifas…',
    pincodeMissing: 'Ingresa un código postal válido para cargar las tarifas de envío.',
    deliveryDays: 'días hábiles',
    standardDelivery: 'Entrega estándar',
    standardDays: '3–5 días hábiles',
    expressDelivery: 'Entrega exprés',
    expressDays: '1–2 días hábiles',
    reviewOrder: 'Revisar pedido',
    deliveryTo: 'Entrega a:',
    continue: 'Continuar',
    back: 'Atrás',
    payNow: 'Pagar',
    stepAddress: 'Dirección',
    stepShipping: 'Envío',
    stepReview: 'Revisión',
    cartEmpty: 'Tu carrito está vacío',
    cartEmptyDesc: 'Agrega artículos antes de proceder al pago',
    continueShopping: 'Continuar comprando',
    // v2.7 — Feature 33 // TODO: professional translation
    noCoverage: 'La entrega no está disponible para este código postal.',
    noCoverageDesc: 'Por favor verifica el código postal o contáctanos.',
    editAddress: 'Editar dirección',
    serviceUnavailable: 'Las opciones de entrega no están disponibles ahora. Se muestran opciones estándar.',
    retryRates: 'Reintentar',
    recommended: 'Recomendado',
  },
  auth: {
    loading: 'Cargando...',
    greeting: 'Hola',
    login: 'Iniciar sesión',
    logout: 'Cerrar sesión',
    anonymous: 'Usuario',
  },
  payment: {
    payPrefix: 'Pagar',
    verifySuccess: '¡Pago verificado y exitoso!',
    verifyFail: 'La verificación del pago falló. Por favor contacta al soporte.',
    verifyError: 'Error de verificación de pago.',
    initiationFail: 'Fallo al iniciar el pago.',
  },
  product: {
    notFound: 'Producto no encontrado',
  },
  authPages: {
    loginHeader: 'Inicia sesión para continuar',
    loginPrompt: 'Por favor inicia sesión para proceder al pago.',
  },
  shop: {
    title: 'Todos los productos',
  },
  products: {
    '1': {
      name: 'Tierra',
      description: 'Productos que aterrizan y nutren, elaborados con arcillas y hierbas naturales, inspirados en la sabiduría de la Madre Tierra.',
    },
    '2': {
      name: 'Agua',
      description: 'Productos calmantes infusionados con aromas acuáticos y aceites esenciales para calmar las emociones.',
    },
    '3': {
      name: 'Fuego',
      description: 'Productos vigorizantes para energizar tu espacio con aromas ardientes.',
    },
    '4': {
      name: 'Aire',
      description: 'Creaciones inspiradas en el Aire, que liberan delicadas fragancias a medida que la inspiración fluye y se abren caminos.',
    },
    '5': {
      name: 'Éter',
      description: 'Diseñado para una limpieza suave: invita claridad, espacio ilimitado y una presencia tácita en el lujo silencioso.',
    },
    '6': {
      name: 'Caja de regalo Panch Tatva',
      description: 'Caja de regalo de lujo curada que contiene los cinco productos elementales para un equilibrio completo.',
    },
  },
  profile: {
    header: 'Perfil',
    loadingProfile: 'Cargando perfil...',
    loadingUserInfo: 'Cargando información del usuario...',
    labels: {
      name: 'Nombre',
      email: 'Correo electrónico',
      firstName: 'Nombre',
      lastName: 'Apellido',
    },
  },
  quiz: {
    cta: 'Encuentra tu Elemento',
    ctaSubtitle: 'Responde 5 preguntas y descubre qué elemento habla a tu piel.',
    title: 'Encuentra tu Elemento',
    subtitle: 'Responde 5 preguntas y encontraremos tu ritual elemental.',
    step: 'Paso',
    of: 'de',
    next: 'Siguiente',
    back: 'Atrás',
    submit: 'Revelar mi Elemento',
    loading: 'Leyendo los elementos…',
    error: 'Algo salió mal. Por favor, inténtalo de nuevo.',
    questions: {
      skinType: { label: '¿Cuál es tu tipo de piel?', options: { dry: 'Seca', oily: 'Grasa', combination: 'Mixta', sensitive: 'Sensible', normal: 'Normal' } },
      climate: { label: '¿Cómo es tu clima?', options: { hot_humid: 'Caliente y húmedo', dry_arid: 'Seco y árido', cold: 'Frío', temperate: 'Templado' } },
      concern: { label: '¿Cuál es tu principal preocupación de piel?', options: { hydration: 'Hidratación', acne: 'Acné', anti_aging: 'Antienvejecimiento', glow: 'Luminosidad', soothing: 'Calmante' } },
      texture: { label: '¿Qué textura prefieres?', options: { rich: 'Rica y cremosa', light: 'Ligera', solid: 'Barra sólida', none: 'Sin preferencia' } },
      fragrance: { label: '¿Qué aroma te atrae?', options: { earthy: 'Terroso', fresh: 'Fresco y floral', citrus: 'Cítrico', unscented: 'Sin fragancia' } },
    },
    result: {
      title: 'Tu Elemento es',
      secondary: 'con un toque de',
      rationale: 'Por qué esto funciona para ti',
      recommendedProducts: 'Tus productos elementales',
      addSet: 'Añadir set recomendado al carrito',
      retake: 'Repetir quiz',
      shopAll: 'Ver todos los elementos',
      elements: { earth: 'Tierra', water: 'Agua', fire: 'Fuego', air: 'Aire', ether: 'Éter' },
      elementDescriptions: { earth: 'Tierra · Nutritivo · Profundo', water: 'Hidratante · Refrescante · Suave', fire: 'Purificante · Energizante · Claro', air: 'Refrescante · Ligero · Libre', ether: 'Equilibrado · Sutil · Puro' },
    },
  },
  chat: {
    title: 'Tatva',
    subtitle: 'Tu guía elemental',
    placeholder: 'Pregúntame lo que quieras…',
    send: 'Enviar',
    loading: 'Pensando…',
    error: 'No se pudo conectar con Tatva. Por favor, inténtalo de nuevo.',
    escalatePrompt: '¿Quieres que cree un ticket de soporte?',
    escalateYes: 'Sí, por favor',
    escalateNo: 'No, gracias',
    ticketSuccess: 'Ticket de soporte creado. Te responderemos en 24 horas.',
    ticketError: 'No se pudo crear el ticket. Escríbenos por correo.',
    emailPlaceholder: 'Tu dirección de correo',
    openLabel: 'Chatear con Tatva',
    closeLabel: 'Cerrar chat',
  },
  admin: {
    // Dashboard
    dashboard: 'Panel de administración',
    dashboardSubtitle: 'Gestiona tus operaciones Panch Tatva',
    totalRevenue: 'Ingresos totales',
    totalOrders: 'Pedidos totales',
    totalCustomers: 'Clientes totales',
    pendingActions: 'Acciones pendientes',
    requiresAttention: 'Requiere atención',
    thisMonth: 'Este mes',
    allTime: 'De todos los tiempos',
    isActive: 'Activo',
    topProducts: 'Productos destacados',
    recentOrders: 'Pedidos recientes',
    systemHealth: 'Estado del sistema',
    razorpay: 'Razorpay',
    database: 'Base de datos',

    // Navigation
    products: 'Productos',
    orders: 'Pedidos',
    customers: 'Clientes',
    finance: 'Finanzas',
    reconciliation: 'Reconciliación',
    settings: 'Configuración',
    manage: 'Gestionar',

    // Products Page
    manageProducts: 'Agregar, editar, eliminar productos y gestionar inventario',
    manageYourInventory: 'Gestiona tu inventario de productos',
    productName: 'Nombre del producto',
    element: 'Elemento',
    price: 'Precio',
    costPrice: 'Precio de costo',
    quantity: 'Cantidad',
    warehouseLocation: 'Ubicación del almacén',
    description: 'Descripción',
    imageUrl: 'URL de imagen',
    allStatus: 'Todos los estados',
    active: 'Activo',
    discontinued: 'Descontinuado',
    draft: 'Borrador',
    profit: 'Margen de beneficio',
    searchProducts: 'Buscar productos...',
    noProducts: 'No se encontraron productos',
    addProduct: '+ Agregar producto',
    editProduct: 'Editar producto',
    addNewProduct: 'Agregar nuevo producto',
    actions: 'Acciones',
    edit: 'Editar',
    delete: 'Eliminar',
    cancel: 'Cancelar',
    previous: 'Anterior',
    next: 'Siguiente',
    page: 'Página',
    of: 'de',

    // Orders Page
    manageAllOrders: 'Ver y gestionar todos los pedidos de clientes',
    manageOrders: 'Rastrear pedidos, procesar reembolsos, crear pedidos manuales',
    orderId: 'ID de pedido',
    customer: 'Cliente',
    amount: 'Cantidad',
    status: 'Estado',
    date: 'Fecha',
    searchOrders: 'Buscar por ID de pedido, correo...',
    noOrders: 'No se encontraron pedidos',
    pendingPayment: 'Pago pendiente',
    confirmed: 'Confirmado',
    shipped: 'Enviado',
    delivered: 'Entregado',
    cancelled: 'Cancelado',
    refunded: 'Reembolsado',
    refund: 'Reembolso',
    refundOrder: 'Reembolsar pedido',
    refundAmount: 'Cantidad de reembolso',
    maxRefund: 'Máx',
    reason: 'Razón',
    selectReason: 'Seleccionar razón',
    notes: 'Notas',
    processRefund: 'Procesar reembolso',

    // Customers Page
    manageAllCustomers: 'Ver y gestionar todas las cuentas de clientes',
    manageCustomers: 'Ver detalles del cliente e historial de pedidos',
    email: 'Correo',
    phone: 'Teléfono',
    lastOrder: 'Último pedido',
    view: 'Ver',
    searchCustomers: 'Buscar por correo, nombre, teléfono...',
    noCustomers: 'No se encontraron clientes',
    customerInfo: 'Información del cliente',
    createdAt: 'Miembro desde',
    lastLogin: 'Último acceso',
    totalSpent: 'Total gastado',
    avgOrderValue: 'Pedido promedio',
    memberStatus: 'Estado',
    addresses: 'Direcciones',
    orderHistory: 'Historial de pedidos',
    close: 'Cerrar',

    // Finance Page
    viewFinancialData: 'Rastrear transacciones y reportes financieros',
    manageFinance: 'Ver transacciones, reportes P&L, contabilidad',
    netRevenue: 'Ingresos netos',
    afterRefunds: 'Después de reembolsos',
    grossProfit: 'Beneficio bruto',
    margin: 'margen',
    netProfit: 'Beneficio neto',
    roi: 'ROI',
    topProductsByRevenue: 'Productos principales por ingresos',
    unitsSold: 'unidades vendidas',
    transactionFilters: 'Filtros de transacciones',
    dateFrom: 'Desde la fecha',
    dateTo: 'Hasta la fecha',
    successful: 'Exitoso',
    pending: 'Pendiente',
    failed: 'Fallido',
    type: 'Tipo',
    searchTransactions: 'Buscar transacciones...',
    noTransactions: 'No se encontraron transacciones',

    // Reconciliation Page
    detectAndResolveIssues: 'Detectar y resolver discrepancias en inventario, pagos y pedidos',
    manageReconciliation: 'Detectar y resolver discrepancias, ejecutar auditorías',
    openIssues: 'Problemas abiertos',
    critical: 'Crítico',
    warnings: 'Advertencias',
    info: 'Información',
    allSeverity: 'Todos los niveles de gravedad',
    noIssuesFound: 'No se encontraron problemas',
    resolveMismatch: 'Resolver discrepancia',
    issue: 'Problema',
    expected: 'Esperado',
    actual: 'Real',
    difference: 'Diferencia',
    detected: 'Detectado',
    product: 'Producto',
    resolve: 'Resolver',
    selectAction: 'Seleccionar acción',
    confirm: 'Confirmar',
    resolved: 'Resuelto',
    ignored: 'Ignorado',

    // Admin User Management
    manageAdmins: 'Gestionar Administradores',
    adminUsers: 'Usuarios Administradores',
    promoteUser: 'Promover a Administrador',
    demoteUser: 'Degradar a Usuario',
    viewDetails: 'Ver Detalles',
    searchByEmail: 'Buscar por correo electrónico o nombre...',
    filterByRole: 'Filtrar por rol',
    allRoles: 'Todos los Roles',
    roleAdmin: 'Administrador',
    roleSuperadmin: 'Superadministrador',
    dateAssigned: 'Fecha de Asignación',
    assignedBy: 'Asignado por',
    confirmDemote: 'Confirmar Degradación',
    demoteWarning: 'Este usuario perderá todo acceso de administrador y permisos. Esta acción no se puede deshacer.',
    noAdminsFound: 'No se encontraron usuarios administradores',
    selectTargetRole: 'Seleccionar rol de destino',
    promoteReason: 'Razón de promoción (opcional)',
    demoteReason: 'Razón de degradación (opcional)',
    statusHistory: 'Historial de Estado',
    promotedOn: 'Promovido el',
    demotedOn: 'Degradado el',
    userNotFound: 'Usuario no encontrado',
    alreadyAdmin: 'Este usuario ya es administrador',
    promoteSuccess: 'Usuario promovido exitosamente',
    demoteSuccess: 'Usuario degradado exitosamente',
    backToDashboard: '← Volver al Panel',

    // Common
    loading: 'Cargando...',
    error: 'Error al cargar',
    units: 'unidades',
  },
  shipment: {
    paymentReceived: '¡Pago recibido!', // TODO: professional translation
    paymentFailed: 'Pago fallido',
    paymentFailedDesc: 'No se pudo procesar su pago. Por favor intente de nuevo.',
    retryPayment: 'Reintentar pago',
    creatingShipment: 'Creando envío...',
    creatingShipmentDesc: 'Estamos preparando su pedido para el envío (normalmente 5–30 segundos).',
    checkingStatus: 'Verificando estado...',
    checkingStatusDesc: 'Verificando con nuestro socio logístico. Debería completarse en 5 minutos.',
    delayedDesc: 'Estamos preparando su envío. Gracias por su paciencia.',
    shipmentFailed: 'Error al crear el envío',
    shipmentFailedDesc: 'No se pudo crear su envío ahora mismo. Nuestro equipo lo revisará.',
    permanentFailed: 'El pedido requiere atención',
    permanentFailedDesc: 'No se pudo crear el envío después de varios intentos. Por favor contacte soporte.',
    contactSupport: 'Contactar soporte',
    shipmentCreated: '¡Su pedido ha sido enviado!',
    shipmentCreatedDesc: 'Su paquete está en camino. Rastréelo a continuación.',
    awbCode: 'Código AWB',
    courier: 'Mensajero',
    trackingStatus: 'Estado',
    viewTracking: 'Ver seguimiento en tiempo real →',
    estimatedDelivery: 'Entrega estimada',
    inTransit: 'En tránsito',
    inTransitDesc: 'Su paquete está en camino.',
    outForDelivery: 'En reparto',
    outForDeliveryDesc: '¡Su paquete llegará hoy!',
    delivered: '¡Entregado!',
    deliveredDesc: 'Su pedido ha sido entregado. ¡Gracias por comprar con nosotros!',
    trackOrder: 'Rastrear pedido',
    shopAgain: 'Comprar de nuevo',
    orderConfirmedNote: 'Pago verificado y pedido confirmado.',
    pollingNote: 'Esta página se actualiza automáticamente — no es necesario actualizar.',
    retryShipment: 'Reintentar envío',
  },
  orderConfirmation: {
    title: '¡Pedido confirmado!',
    subtitle: 'Gracias por su compra. Su pedido ha sido confirmado.',
    orderId: 'ID de pedido',
    orderDate: 'Fecha del pedido',
    total: 'Monto total',
    items: 'Artículos',
    shippingAddress: 'Dirección de envío',
    priceSummary: 'Resumen de precios',
    subtotal: 'Subtotal',
    shipping: 'Envío',
    free: 'Gratis',
    tax: 'Impuesto (18% GST)',
    confirmationEmail: 'Correo de confirmación',
    confirmationEmailDesc: 'Se envió un correo de confirmación a',
    whatsNext: '¿Qué sigue?',
    orderConfirmedStep: 'Pedido confirmado',
    preparingStep: 'Preparando',
    shippedStep: 'Enviado',
    deliveredStep: 'Entregado',
    viewOrderHistory: 'Ver historial de pedidos',
    continueShopping: 'Continuar comprando',
    viewReceipt: 'Ver recibo', // TODO: professional translation
    guestPrompt: 'Crea una cuenta para seguir este pedido', // TODO: professional translation
    guestPromptDesc: 'Regístrate para ver tu historial de pedidos, rastrear entregas y volver a pedir con un clic.', // TODO: professional translation
    guestPromptCta: 'Crear cuenta', // TODO: professional translation
  },
  orderDetails: {
    title: 'Pedido',
    orderedOn: 'Pedido el',
    orderTimeline: 'Línea de tiempo del pedido',
    orderStatus: 'Estado actual',
    orderSummary: 'Resumen del pedido',
    itemsOrdered: 'Artículos',
    shippingAddress: 'Dirección de envío',
    shipmentInfo: 'Información de envío',
    awbCode: 'Código AWB',
    courier: 'Mensajero',
    tracking: 'Seguimiento',
    viewTracking: 'Rastrear paquete',
    estDelivery: 'Entrega estimada',
    subtotal: 'Subtotal',
    shipping: 'Envío',
    free: 'Gratis',
    tax: 'Impuesto',
    total: 'Total',
    printInvoice: 'Imprimir factura',
    viewReceipt: 'Ver recibo', // TODO: professional translation
    reorder: 'Repetir pedido',
    helpSupport: 'Ayuda y soporte',
    needHelp: '¿Necesita ayuda con su pedido?',
    contactSupport: 'Contactar soporte',
    backToOrders: 'Volver a pedidos',
    quantity: 'Cantidad',
    price: 'Precio',
    loadingOrder: 'Cargando detalles del pedido...',
    orderNotFound: 'Pedido no encontrado.',
    failedToLoad: 'Error al cargar los detalles del pedido.',
  },
  adminShipment: { // TODO: professional translation
    shipmentStatusCol: 'Envío',
    awbCol: 'AWB / Mensajero',
    filterAll: 'Todos los envíos',
    filterProcessing: 'Procesando',
    filterRetrying: 'Reintentando',
    filterFailed: 'Fallido',
    filterShipped: 'Enviado',
    filterNotStarted: 'No iniciado',
    failedShipmentsAlert: 'Envíos fallidos — clic para filtrar',
    awbPending: 'Pendiente',
    expandTitle: 'Ver detalles del envío',
    retryButton: 'Reintentar envío',
    retryButtonTitle: 'Forzar reintento de creación de envío vía cola admin',
    retryInFlight: 'En cola…',
    retryQueuedToast: 'Reintento en cola — actualice en unos segundos para ver el estado.',
    retryModalTitle: 'Reintentar envío',
    retryModalSubtitle: 'Esto pondrá en cola un nuevo intento de creación de envío. El resultado es asíncrono.',
    retryOrderId: 'ID del pedido',
    retryReason: 'Motivo del reintento',
    optional: 'opcional',
    retryReasonPlaceholder: 'p.ej. Dirección confirmada, problema de mensajero resuelto…',
    retryConfirm: 'Poner en cola',
    retryInProgress: 'Poniendo en cola…',
    retryAsyncNote: '⚡ El reintento es asíncrono — la creación del envío ocurre en segundo plano.',
    retryQueued: 'Reintento en cola correctamente.',
    retryAlreadyCreated: 'Este envío ya fue creado correctamente.',
    retryRateLimit: 'Límite de solicitudes alcanzado. Espere un momento.',
    retryServiceUnavailable: 'El servicio de envío no está disponible. Intente más tarde.',
    retryNotReady: 'El pedido aún no está listo para reintento.',
    retryError: 'Error al poner en cola el reintento.',
    close: 'Cerrar',
    cancel: 'Cancelar',
    detailSectionTitle: 'Detalles del envío',
    detailStatus: 'Estado',
    detailShipmentId: 'ID de envío',
    detailAwb: 'Código AWB',
    detailCourier: 'Mensajero',
    detailTracking: 'URL de seguimiento',
    trackLink: 'Rastrear paquete',
    detailShippingStatus: 'Estado de envío',
    detailEdd: 'Entrega estimada',
    detailAsyncNote: '⚡ El envío se está creando de forma asíncrona — los datos se actualizarán al completarse.',
    noShipmentData: 'Sin datos de envío aún.',
  },
  adminMonitor: { // TODO: professional translation
    title: 'Monitor de Envíos',
    subtitle: 'Panel de operaciones en tiempo real — detectar y resolver problemas de envío',
    navTitle: 'Monitor de Envíos',
    navDesc: 'Operaciones de envío en tiempo real — fallos, pedidos bloqueados, infracciones SLA',
    metricProcessing: 'Procesando',
    metricRetrying: 'Reintentando',
    metricFailed: 'Fallo Permanente',
    metricCompleted: 'Enviado Hoy',
    metricStuck: 'Bloqueado (>10 min)',
    metricSlaBreach: 'Infracción SLA',
    alertsTitle: 'Necesita Atención',
    alertStuck: 'Pedido Bloqueado',
    alertSla: 'Infracción SLA',
    alertFailed: 'Fallo Permanente',
    noAlerts: 'Sin problemas críticos — todos los envíos están bien',
    filterAll: 'Todos',
    filterProcessing: 'Procesando',
    filterRetrying: 'Reintentando',
    filterFailed: 'Fallido',
    filterShipped: 'Enviado',
    filterStuck: 'Bloqueado',
    filterSlaBreach: 'Infracción SLA',
    filterNeedsAttention: 'Necesita Atención',
    timeFilter1h: 'Última 1h',
    timeFilter24h: 'Últimas 24h',
    timeFilterAll: 'Todo el tiempo',
    colOrderId: 'ID Pedido',
    colCustomer: 'Cliente',
    colPayment: 'Pago',
    colShipment: 'Envío',
    colAwb: 'AWB',
    colFailureReason: 'Razón de Fallo',
    colDuration: 'Duración',
    colSla: 'Límite SLA',
    colActions: 'Acciones',
    awbPending: 'Pendiente',
    noOrders: 'Ningún pedido coincide con los filtros actuales.',
    noShipmentData: 'Sin datos de envío disponibles.',
    detailTitle: 'Registro Completo de Envío',
    trackLink: 'Abrir seguimiento',
    autoRefresh: 'Auto-actualizar',
    autoRefreshOn: 'ACTIVADO',
    autoRefreshOff: 'DESACTIVADO',
    lastUpdated: 'Última actualización',
    manualRefresh: 'Actualizar ahora',
    refreshing: 'Actualizando…',
    actionRetry: 'Reintentar',
    actionDetails: 'Detalles',
    retryModalTitle: 'Reintentar Envío',
    retryModalSubtitle: 'Poner en cola un nuevo intento de creación de envío (async — revisa en ~30s)',
    retryOrderId: 'ID Pedido',
    retryReason: 'Motivo del reintento',
    optional: 'opcional',
    retryReasonPlaceholder: 'ej. Dirección confirmada, problema de mensajería resuelto…',
    retryConfirm: 'Poner en Cola',
    retryInProgress: 'Poniendo en cola…',
    cancel: 'Cancelar',
    close: 'Cerrar',
    retryQueued: 'Reintento en cola — actualiza en unos segundos.',
    retryQueuedToast: 'Reintento en cola — actualiza para ver el estado.',
    retryAlreadyCreated: 'Envío ya creado. Actualiza para ver el último estado.',
    retryRateLimit: 'Límite de tasa — espera antes de reintentar.',
    retryServiceUnavailable: 'Servicio de envío no disponible. Inténtalo más tarde.',
    retryError: 'Error al reintentar. Por favor, inténtalo de nuevo.',
    retryNotReady: 'Pedido no listo para reintentar aún.',
    retryAsyncNote: '⚡ El reintento es async — el pedido se actualizará en 30 segundos.',
  },
  reconciliationMonitor: { // TODO: professional translation
    title: 'Monitor de Reconciliación',
    subtitle: 'Panel de integridad de datos en vivo — detecta inconsistencias de pago, pedido y envío',
    navTitle: 'Monitor de Reconciliación',
    navDesc: 'Monitoreo en vivo de integridad de datos — pagos huérfanos, pedidos atascados, reconciliaciones fallidas',
    metricOrphaned: 'Pagos Huérfanos',
    metricOrphanedTitle: 'Pago realizado pero sin envío iniciado (>15 min)',
    metricFailedReconciling: 'Reconciliación Fallida',
    metricFailedReconcilingTitle: 'Creación de envío en reintento',
    metricPermanentFailed: 'Fallo Permanente',
    metricPermanentFailedTitle: 'Todos los reintentos agotados',
    metricStuck: 'Atascado (>10 min)',
    metricStuckTitle: 'Procesamiento más largo que el umbral',
    metricSlaBreach: 'SLA Incumplido',
    metricSlaBreachTitle: 'Plazo superado, no completado',
    metricReconciled: 'Reconciliados Hoy',
    metricReconciledTitle: 'Completados con éxito en las últimas 24h',
    alertsTitle: 'Problemas Críticos — Atención Inmediata Requerida',
    noAlerts: 'Sin problemas de integridad de datos — todos los sistemas consistentes',
    alertsOverflow: '+{n} más — usa los filtros abajo para ver todos',
    autoRefresh: 'Auto-actualizar',
    autoRefreshOn: 'ACTIVO',
    autoRefreshOff: 'INACTIVO',
    lastUpdated: 'Última actualización',
    manualRefresh: 'Actualizar ahora',
    refreshing: 'Actualizando…',
    runReconciliation: 'Ejecutar reconciliación',
    reconRunning: 'Ejecutando…',
    reconciliationTriggered: '✓ Reconciliación iniciada — los resultados aparecerán en breve',
    exportCsv: 'Exportar CSV',
    actionView: 'Ver',
    actionRetry: 'Reintentar',
    actionReconcile: 'Reconciliar',
    filterLabel: 'Filtrar:',
    filterAll: 'Todos',
    filterOrphaned: 'Pagos Huérfanos',
    filterFailedReconciling: 'Reintentando',
    filterPermanentFailed: 'Fallo Permanente',
    filterStuck: 'Atascado',
    filterSlaBreach: 'SLA Incumplido',
    filterNeedsAttention: 'Necesita Atención',
    timeFilter1h: 'Última 1h',
    timeFilter24h: 'Últimas 24h',
    timeFilterAll: 'Todo el tiempo',
    colOrderId: 'ID Pedido',
    colPayment: 'Pago',
    colShipment: 'Envío',
    colIssueType: 'Tipo de Problema',
    colDuration: 'Procesamiento',
    colSla: 'Plazo SLA',
    colLastUpdated: 'Última Act.',
    colActions: 'Acciones',
    noOrders: 'Ningún pedido coincide con los filtros actuales.',
    noShipmentData: 'No hay datos de envío disponibles.',
    detailTitle: 'Registro Completo',
    selectedOrders: 'pedidos seleccionados',
    bulkRetry: 'Reintentar todos los seleccionados',
    bulkRetrying: 'Poniendo en cola…',
    clearSelection: 'Limpiar',
    // Tabs
    tabHealth: '🟢 Salud en Vivo', // TODO: professional translation
    tabMismatches: '🔎 Discrepancias', // TODO: professional translation
  },
  receipt: {
    title: 'Recibo', // TODO: professional translation
    receiptNumber: 'N° Recibo',
    issuedDate: 'Emitido',
    orderId: 'ID de Pedido',
    customerInfo: 'Cliente',
    billingAddress: 'Dirección de Facturación',
    orderItems: 'Artículos del Pedido',
    columnProduct: 'Producto',
    columnQty: 'Cant.',
    columnUnit: 'Precio Unit.',
    columnTotal: 'Total',
    subtotal: 'Subtotal',
    tax: 'Impuesto',
    shipping: 'Envío',
    total: 'Total',
    free: 'Gratis',
    paymentInfo: 'Pago',
    paymentMethod: 'Método',
    paymentId: 'ID de Pago',
    paymentStatus: 'Estado',
    paid: 'Pagado',
    printReceipt: 'Imprimir Recibo',
    downloadPdf: 'Descargar PDF',
    backToOrder: 'Volver al Pedido',
    currency: '₹',
    loading: 'Cargando recibo…', // TODO: professional translation
    errorTitle: 'No se pudo cargar el recibo', // TODO: professional translation
    errorNotFound: 'Este recibo no está disponible. Es posible que el pedido aún no haya sido pagado.', // TODO: professional translation
    errorForbidden: 'No tienes permiso para ver este recibo.', // TODO: professional translation
    errorRateLimit: 'Demasiadas solicitudes — espera un momento e inténtalo de nuevo.', // TODO: professional translation
    errorGeneric: 'Algo salió mal. Por favor, inténtalo de nuevo.', // TODO: professional translation
    pdfError: 'Error al descargar el PDF. Por favor, inténtalo de nuevo.', // TODO: professional translation
    pdfRateLimit: 'Demasiadas solicitudes — espera un momento antes de descargar.', // TODO: professional translation
    tryAgain: 'Intentar de nuevo', // TODO: professional translation
  },
};

export default es;
